export default {
  packs: {
    packListTab: {
      title: "Список пачок",
      reasonReturningPackForm: {
        modal: {
          title: "Причина повернення пачки",
          form: {
            reasons: "Причина"
          }
        }
      },
      alert: {
        postingAllPrepare: "Немає жодної пачки для рознесення.",
        lastMessagePackVerification: {
          verificationCompleted: "Перевірка завершена.",
          checked: "Перевірено",
          bugsFound: "Виявлено помилок:"
        },
        postingAllContinue: "Рознесення пачок завершено"
      },
      confirm: {
        postingPrepare: "Рознести вибрану пачку по о/рахункам?",
        postingAllPrepare: {
          messageCountPacks: "Кількість пачок для рознесення",
          messagePostingAll: "Запустити рознесення пачок по о/рахункам?"
        },
        onReturnBtn:
          "Встановити помилковість вибраної пачки і відправити її бухгалтерові?",
        onPostponeBtn:
          "Відкласти вибрану пачку для автоматичної розноски вночі?",
        onPostingAllBtn: "Рознести усі коректно заповнені пачки по о/рахункам?"
      }
    },
    packSelectedTab: {
      title: "Пачка №",
      countbandsEditForm: {
        modal: {
          title: {
            payments: "Бандероль",
            subsidies: "Аркуш"
          }
        },
        form: {
          number: {
            payments: "Номер бандеролі",
            subsidies: "Номер аркуша"
          },
          quantity: {
            payments: "Кількість квитанцій",
            subsidies: "Кількість абонентів"
          },
          totalSum: "Загальна сума"
        }
      },
      countbandsName: {
        payments: "Бандеролі",
        subsidies: "Аркуші"
      },
      oneCountbandName: {
        payments: "Бандероль №",
        subsidies: "Аркуш №"
      },
      countbandsTotal: {
        pack: "По пачці",
        payments: {
          countband: "По бандеролі",
          countbands: "По бандеролях",
          receipts: "За квитанціями"
        },
        subsidies: {
          list: "По аркушу",
          lists: "По аркушах",
          socials: "За субсидіями/соц.доплатами"
        }
      },
      paymentTitle: {
        compensationForVisuallyImpaired:
          "Компенсація інвалідам по зору А: {countband} С: {receipt}",
        socialSurcharge: "Соц.доплата А: {countband} С: {receipt}",
        subsidy: "Субсидія А: {countband} С: {receipt}",
        receipt: "Квитанція Б: {countband} Кв: {receipt}"
      },
      alert: {
        importPackIsNotChanged:
          "Дані імпортованої пачки не можуть бути змінені",
        maxCountbandsHasAlreadyBeenEntered:
          "Необхідну кількість бандеролей вже внесено",
        maxListsHasAlreadyBeenEntered:
          "Необхідна кількість аркушів вже внесено",
        deleteCountband: "Видалити бандероль?",
        deleteList: "Видалити аркуш?",
        maxReceiptsHasAlreadyBeenEntered:
          "Необхідну кількість квитанцій вже внесено",
        maxSubsidiesHasAlreadyBeenEntered:
          "Необхідну кількість субсидій вже внесено"
      },
      confirm: {
        deletePayment: "Видалити платіж?",
        deleteAllCountband: "Видалити вміст бандеролі?",
        deleteAllList: "Видалити вміст листа?"
      }
    }
  }
};
